import React from 'react';
import PropTypes from 'prop-types';

import { PromotedPost } from 'features/blog/promoted-post';
import { TypesView } from 'features/blog/types/view';
import { ListView } from 'features/blog/list/view';
import { PaginationView } from 'utilities/components/pagination/component/view';

import './view.scss';
import { TagsView } from '../tags/view';

export const BlogView = ({
    types,
    posts,
    currentType,
    currentPage,
    tags,
    currentTag,
    location
}) => {
    const limitPerPage = 12;
    const pagesNumber = Math.ceil(posts.length / limitPerPage);
    const offset = (currentPage - 1);
    const startPage = offset * limitPerPage;
    const endPage = posts.length - offset * limitPerPage > limitPerPage ? offset * limitPerPage + limitPerPage : posts.length;

    return (
        <div className="blog">
            <PromotedPost currentType={ currentType } />
            <div className="blog__container">
                <TypesView types={ types } currentType={ currentType } location={ location } />
                <TagsView tags={ tags } currentTag={ currentTag } currentType={ currentType } location={ location } />
                <ListView posts={ posts } startPage={ startPage } endPage={ endPage } />
                {
                    (limitPerPage < posts.length)
                        && (<PaginationView numberOfPages={ pagesNumber } activePage={ currentPage } />)
                }
            </div>
        </div>
    );
};

BlogView.propTypes = {
    types: PropTypes.instanceOf(Array).isRequired,
    posts: PropTypes.instanceOf(Array).isRequired,
    currentType: PropTypes.string.isRequired,
    currentPage: PropTypes.string.isRequired,
    currentTag: PropTypes.string.isRequired,
    tags: PropTypes.instanceOf(Array).isRequired,
    location: PropTypes.shape({ search: PropTypes.string }).isRequired
};